import { FC, ReactElement } from 'react';

import { EvSwitch } from '@evinced-private/ui-common';

import './BestPracticesButton.scss';

interface IBestPracticesButton {
	onChange: (withBestPractices: boolean) => void;
	withBestPractices: boolean;
}

export const BestPracticesButton: FC<IBestPracticesButton> = ({
	onChange,
	withBestPractices
}): ReactElement => {
	return (
		<EvSwitch
			onChange={onChange}
			checked={withBestPractices}
			label="Include Best Practices"
			className="include-best-practices"
		/>
	);
};
